export default __webpack_public_path__ + "static/media/employeeDirectory.7f95ae1e.png";